import React from "react";
import { gql, useQuery } from "urql";
import { ProductTile } from "./components/ProductTile";
import { Spinner } from "./components/spinner";
import { Social } from "./components/social";
import { CtaFooter } from "./components/cta-footer";

import "./tools.scss";
import "./gallery.scss";

const ALL_TOOL_QUERY = gql`
  query {
    allTool(sort: { priority: ASC }, where: { visible: { eq: true } }) {
      title
      priority
      description
      slug {
        current
      }

      mainImage {
        asset {
          url
        }
      }
      categories {
        id
        name
      }
      apps {
        id
        name
        icon {
          asset {
            url
          }
        }
      }
      bodyRaw
    }
  }
`;

const Tools = () => {
  const [result] = useQuery({ query: ALL_TOOL_QUERY });
  const { data, fetching, error } = result;
  return (
    <>
      <div className="gallery--wrapper">
        <h1 className="title-content gallery--title">Tools</h1>
        <div className="gallery--description">
          We've developed several After Effects scripts and Premiere Pro scripts
          including our most widely known tool, Pro IO.
        </div>

        {(data && data.allTool && (
          <div className="tile-wrapper tools--tile-wrapper">
            {data.allTool.map((tool: any, i: number) => {
              return (
                <ProductTile
                  key={i}
                  image={tool.mainImage?.asset.url}
                  title={tool.title}
                  description={tool.description}
                  link={`/tools/${tool.slug.current}/`}
                  index={i}
                  tags={
                    tool.categories && tool.categories.map((cat) => cat.name)
                  }
                  apps={tool.apps}
                />
              );
            })}
          </div>
        )) || <Spinner />}
      </div>
      <CtaFooter />
      <Social />
    </>
  );
};

export default Tools;
